import React from 'react'
import './TermsAndCondition.css'
import Shipping from './Shipping'
import Contact from './Contact'

function TermsAndCondition() {
  return (
    <div className="legal-page">
        
        <h5>Last updated on August 1, 2025</h5>

For the purpose of these Terms and Conditions, the terms "we", "us", "our" shall refer to Amfia Education, operated by Ajay Singh, located at Sai Heights, SN. 83/1 Sai Park Road, Dighi, Pune, Maharashtra – 411015. The terms "you", "your", "user", "visitor" refer to any individual or entity visiting our website or purchasing/joining our courses.

<p>By using our website and/or enrolling in our courses, you agree to the following terms:</p>

<h5>CEO of Amfia Education</h5>
<p>Ankit Yadav is the CEO of the organization, a dedicated and visionary leader who focuses on growth, innovation, and quality. With strong experience in managing operations and building meaningful relationships, he plays a key role in driving the company’s success. His strategic thinking, leadership skills, and commitment to excellence have helped create a positive impact for both the organization and its stakeholders.
</p>

<h5>Website Content</h5>
<p>The content on this website is for general information only and may be changed without prior notice.</p>

<h5>Accuracy Disclaimer</h5>
<p>We strive to provide accurate, up-to-date, and reliable information through our website and course materials. Our content is carefully designed to support your learning and growth. However, we encourage users to apply their own judgment and seek professional guidance when necessary.</p>

<h5>Use of Services</h5>
<p>You are responsible for ensuring that any course or service you purchase from Amfia Education meets your specific needs.</p>

<h5>Intellectual Property</h5>
<p>All content including text, images, graphics, and layout are the property of Amfia Education and cannot be copied or used without permission.</p>

<h5>Trademarks</h5>
<p>All trademarks used or displayed on this site that are not owned by Amfia Education are the property of their respective owners.</p>

<h5>Unauthorized Use</h5>
<p>Any misuse or unauthorized use of content, material, or communication from us may lead to legal action or penalties.</p>

<h5>External Links</h5>
<p>We may provide links to other websites for convenience. We do not endorse or control the content of those sites.</p>

<h5>Linking Policy</h5>
<p>You may not link to our website without written permission from Amfia Education.</p>

<h5>Jurisdiction</h5>
<p>All disputes will be governed by the laws of India and resolved under courts located in Unnao, Uttar Pradesh.</p>

<h5>Payment Authorization</h5>
<p>We are not responsible for failed transactions due to declined authorization from your bank or payment gateway.</p>
<div className="legal-page">

<Shipping/>
<Contact/>

</div>
  </div>
  )
}

export default TermsAndCondition